<template>
  <div class="edit-lawyer">
    <Form
      ref="formValidate" :model="formValidate"
      :rules="ruleValidate" :label-width="120"
    >
      <Row class="detail-header">
        <span>基本信息</span>
      </Row>
      <Row class="detail-form">
        <FormItem
          v-if="isAdd" label="账号"
          prop="accountName"
          :rules="{required: true, validator: validateAccount, trigger: 'blur'}"
        >
          <Input v-model.trim="formValidate.accountName" placeholder="请输入账号(账号为6-32位的数字和英文字母组合)" />
        </FormItem>
        <FormItem
          v-if="isAdd" label="密码"
          prop="password"
          :rules="{required: true, validator: validatePass, trigger: 'blur'}"
        >
          <Input
            v-model.trim="formValidate.password" autocomplete="new-password"
            type="password" placeholder="请输入密码(数字、字母或者两者组合)"
          />

        </FormItem>
        <!-- :disabled="lawyerDetail.isPrimary"：主账号禁用编辑姓名 -->
        <FormItem label="姓名" prop="name">
          <Input
            v-model.trim="formValidate.name" :disabled="!isAdd && lawyerDetail.isPrimary"
            placeholder="请输入律师姓名"
          />
        </FormItem>
        <FormItem label="性别" prop="sex">
          <RadioGroup v-model="formValidate.sex">
            <Radio
              v-for="item in sexArr" :key="item.id"
              :label="item.value"
            >{{ item.nameZh }}</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="成员类型" prop="memberIdentity">
          <RadioGroup v-model="formValidate.memberIdentity" @on-change="changeMemberIdentity">
            <Radio
              v-for="item in memberIdentityArr" :key="item.id"
              :label="item.value"
            >{{ item.nameZh }}</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="证件类型" prop="certificateType">
          <Select v-model="formValidate.certificateType" placeholder="请选择你的证件类型">
            <Option
              v-for="item in certificateType" :key="item.id"
              :value="item.value"
            >{{ item.nameZh }}</Option>
          </Select>
        </FormItem>
        <FormItem
          label="证件编号" prop="certificateNumber"
          :rules="formValidate.certificateType=='IC'?
            { required: true,type:'string', pattern:/^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/, message: '请正确填写证件编号', trigger: 'blur' }:
            { required: true,type:'string',pattern:/^1[45][0-9]{7}|([P|p|S|s]\d{7})|([S|s|G|g]\d{8})|([Gg|Tt|Ss|Ll|Qq|Dd|Aa|Ff]\d{8})|([H|h|M|m]\d{8，10})$/, message: '请正确填写证件编号', trigger: 'blur' }"
        >
          <Input v-model.trim="formValidate.certificateNumber" placeholder="请输入证件编号" />
        </FormItem>
        <FormItem label="证件照片" prop="certificateAttachs">
          <file-upload
            accept-type=".png,.jpg,.jpeg,.bmp" :default-list="defaultCertificateList || []"
            :upload-config="{}" @getFileList="getAttachmentList"
          />
        </FormItem>
        <!-- :disabled="lawyerDetail.isPrimary"：主账号禁用编辑机构名称 -->
        <FormItem label="机构名称" prop=" lawyerDetail.isPrimary?  lawOffice :''">
          <Input
            v-model.trim="formValidate.lawOffice" :disabled="!isAdd && lawyerDetail.isPrimary"
            placeholder="请输入律所机构"
          />
        </FormItem>
        <FormItem label="联系方式" prop="mobile">
          <Input v-model.trim="formValidate.mobile" placeholder="请输入联系方式" />
        </FormItem>
        <FormItem
          label="电子邮箱" prop="mail"
          :rules="formValidate.mail?[
            {required:true, pattern:/^[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*@[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*\.[a-z]{2,}$/, message:'请输入正确的邮箱', trigger:'blur'},
            { max:32,message:'不能超过32个字符',trigger:'blur' }]:{}"
        >
          <Input v-model.trim="formValidate.mail" placeholder="请输入电子邮箱" />
        </FormItem>
        <FormItem label="地区" prop="province">
          <City
            v-if="detailsCtrl" ref="transEvent"
            :city-list="cityList" style="width:100%;"
            @listenCity="getCity"
          />
        </FormItem>
        <FormItem label="地址" prop="address">
          <Input
            v-model.trim="formValidate.address" type="textarea"
            :autosize="{minRows: 2,maxRows: 5}" placeholder="请输入地址"
          />
        </FormItem>

        <FormItem
          v-if="hasSettlementRange" label="结算范围"
          prop="settlementScope"
        >
          <RadioGroup v-model="formValidate.settlementScope">
            <Radio :label="1">全部案件</Radio>
            <Radio :label="0">分配案件</Radio>
          </RadioGroup>
        </FormItem>

        <FormItem
          v-if="hasSettlementRange&&!lawyerDetail.isPrimary" label="盖章材料范围 "
          prop="materialScope"
        >
          <RadioGroup v-model="formValidate.materialScope">
            <Radio :label="1">团队全部</Radio>
            <Radio :label="0">已分配案件</Radio>

          </RadioGroup>
        </FormItem>

        <FormItem
          v-if="formValidate.memberIdentity=='1'" label="是否接收短信"
          prop="isReceiveSms"
        >
          <RadioGroup v-model="formValidate.isReceiveSms">
            <Radio label="1">是</Radio>
            <Radio label="0">否</Radio>
          </RadioGroup>
        </FormItem>

        <FormItem
          v-if="formValidate.memberIdentity=='1'" label="上传律师签字"
          prop="sealAttachInfo"
        >
          <file-upload
            :default-list="defaultSealList" :upload-config="sealUploadConfig"
            accept-type=".png" @getFileList="getSealFileList"
          />
        </FormItem>
        <Row style="color:red;">
          <Col span="3" style="text-align:right;">注意：</Col>
          <Col span="21" style="padding-left:20px;">请上传400*300像素的PNG（透明底）签字图片</Col>
        </Row>
      </Row>
      <Row v-if="formValidate.memberIdentity=='1'" class="detail-header">
        <span>执业信息</span>
      </Row>
      <Row v-if="formValidate.memberIdentity=='1'" class="detail-form">
        <FormItem
          label="执业证号" prop="lawLicense"
          :rules="[{ required: true, message: '执业编号不能为空', trigger: 'blur' },
                   { max:32,message:'不能超过32个字符',trigger:'blur' }]"
        >
          <Input v-model.trim="formValidate.lawLicense" placeholder="请输入执业证号" />
        </FormItem>
        <FormItem
          label="执业领域" prop="skill"
          :rules="{ required: true, type: 'array', min: 1, message: '请选择擅长领域', trigger: 'change' }"
        >
          <CheckboxGroup v-model="formValidate.skill">
            <Checkbox
              v-for="item in skillArr" :key="item.id"
              :label="item.value"
            ><span>{{ item.nameZh }}</span></Checkbox>
          </CheckboxGroup>
        </FormItem>
        <FormItem label="个人简介" prop="remark">
          <Input
            v-model.trim="formValidate.remark" type="textarea"
            :autosize="{minRows: 2,maxRows: 5}" placeholder="请输入个人简介"
          />
        </FormItem>
        <FormItem
          label="上传证件" prop="qualifications"
          :rules="{required: true,type:'array', message: '证件不能为空', trigger: 'blur'}"
        >
          <file-upload
            :default-list="defaultList" :upload-config="uploadConfig"
            @getFileList="getFileList"
          />
        </FormItem>
      </Row>
      <Row v-if="formValidate.memberIdentity=='1'" class="detail-header">
        <span>历史单位</span>
      </Row>
      <Row v-if="formValidate.memberIdentity=='1'" class="detail-form">
        <div
          v-for="(item, index) in formValidate.jobTime"
          :key="index"
          :label-width="0"
        >
          <FormItem
            label="执业时间"
            class="form-add"
          >
            <DatePicker
              v-model="item.usedTime" type="daterange"
              placement="bottom-end" placeholder="请选择执业时间"
              style="width:calc(100% - 80px)"
            />
            <Button
              v-if="index==0" class="addBtn"
              type="primary" @click="handleAdd"
            >添加</Button>
            <Button
              v-if="index!=0" class="addBtn"
              type="error" @click="handleRemove(index)"
            >删除</Button>
          </FormItem>
          <FormItem label="过往律所" :rules="{ max:100,message:'不能超过100个字符',trigger:'blur' }">
            <Input v-model.trim="item.office" placeholder="请输入过往律所" />
          </FormItem>
        </div>
      </Row>
    </Form>
    <Row class="detail-form" :style="{textAlign:'center'}">
      <Button
        type="primary" style="margin-right:10px;"
        :disabled="isSubmit" @click="handleSubmit('formValidate')"
      >保存</Button>
      <Button @click="$emit('changeEditCtrl',false);">取消</Button>
    </Row>
  </div>
</template>
<script>
import City from '@/components/common/city/city'
import fileUpload from '@/components/common/fileUpload/fileUpload.vue'
// import chooseCityNew from '@/components/common/chooseCity/chooseCity.vue'
export default {
  components: {
    City,
    fileUpload
    // chooseCityNew
  },
  props: {
    lawyerDetail: {
      type: [Object, String]
    },
    isAdd: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: '100%'
    },
    hasSettlementRange: {
      type: Boolean,
      defaul: false
    }
  },
  data () {
    const validateAccount = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('账号不能为空'))
      }
      if (value.length < 6 || value.length > 32) {
        return callback(new Error('长度不能少于6个字符或超过32个字符'))
      }
      if (/^[^\d]*$|^[^a-zA-Z]*$|[^\da-zA-Z]/.test(value)) {
        return callback(new Error('账号仅使用数字和字母组合'))
      }
      if (value && (value === this.prevAccountName)) {
        return callback()
      }
      const url = '/base/account/check?accountName=' + value
      this.$get(url).then(res => {
        if (res.code === 0 && (!res.data)) {
          callback()
        } else {
          callback(new Error('账号已存在'))
        }
      })
    }
    const validatePhone = (rules, value, callback) => {
      if (!value) {
        return callback(new Error('请输入手机号码'))
      }
      if (!/^[1][3,4,5,6,7,8,9][0-9]{9}$/.test(value)) {
        return callback(new Error('请输入正确的手机号码'))
      }
      if (value && value === this.prevMobile) {
        return callback()
      }
      const url = '/base/account/check-mobile?mobile=' + value
      this.$get(url).then(res => {
        if (res.code === 0 && res.data) {
          return callback(new Error(res.message))
        } else {
          callback()
        }
      })
    }
    const validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码!'))
      } else {
        if (/[\u4e00-\u9fa5]/g.test(value)) {
          callback(new Error('格式错误!'))
        } else if (/[\`\~\!\！\、\。\，\@\#\$\%\^\&\*\+\\\]\}\{\'\;\:\"\/\.\,\>\<\s\|\=\-\?]/g.test(value)) {
          callback(new Error('格式错误!'))
        } else if (value.length > 32) {
          callback(new Error('密码长度不能超过32个字符!'))
        } else {
          callback()
        }
      }
    }
    return {
      validateAccount: validateAccount,
      validatePass: validatePass,
      sexArr: [],
      skillArr: [], // 擅长领域
      certificateType: [], // 证件类型
      memberIdentityArr: [], // 成员类型
      // 基本信息
      formValidate: {
        accountName: '',
        password: '',
        memberIdentity: '0',
        name: '',
        sex: 'M',
        certificateType: 'IC',
        certificateNumber: '',
        lawOffice: '',
        mobile: '',
        mail: '',
        province: '',
        city: '',
        area: '',
        address: '',
        lawLicense: '',
        materialScope: 0,
        settlementScope: null,
        skill: [],
        lawLicenseUrl: [],
        remark: '',
        // fxNotary: 'Y',
        isReceiveSms: '0',
        jobTime: [
          {
            usedTime: [],
            office: ''
          }
        ],
        qualifications: [],
        sealAttachId: '',
        sealAttachInfo: [],
        certificateAttachs: []
      },
      ruleValidate: {
        name: [
          { required: true, message: '姓名不能为空', trigger: 'blur' },
          { max: 16, message: '不能超过16个字符', trigger: 'blur' }
        ],
        settlementScope: this.hasSettlementRange ? [{ required: true, type: 'number', message: '结算范围不能为空', trigger: 'blur' }] : [{ required: false }],
        gender: [{ required: true, message: '请选择性别', trigger: 'change' }],
        // certificateType:[{ required: true, message: '请选择证件类型', trigger: 'change' }],
        mobile: [{ required: true, validator: validatePhone, trigger: 'blur' }],
        province: [{ required: true, message: '省份不能为空', trigger: 'change' }],
        city: [{ required: true, message: '城市不能为空', trigger: 'change' }],
        // area:[{required: true, message: '地区不能为空', trigger: 'change'}],
        address: [
          { required: true, message: '详细地址不能为空', trigger: 'blur' },
          { max: 128, message: '不能超过128个字符', trigger: 'blur' }
        ],
        lawOffice: [
          { required: true, message: '执业律所不能为空', trigger: 'blur' },
          { max: 32, message: '不能超过32个字符', trigger: 'blur' }
        ],
        // lawLicense:[
        //     { required: true, message: '执业编号不能为空', trigger: 'blur' },
        //     { max:32,message:'不能超过32个字符',trigger:'blur' }
        // ],
        // skill:[{ required: true, type: 'array', min: 1, message: '请选择擅长领域', trigger: 'change' }],
        remark: [{ max: 500, message: '不能超过500个字符', trigger: 'blur' }],
        certificateAttachs: [{ required: true, type: 'array', message: '证件照片不能为空', trigger: 'change' }]
        // qualifications:[{required: true,type:'array', message: '证件不能为空', trigger: 'blur'}],
      },
      cityList: [],
      // 图片上传默认
      defaultList: [],
      defaultSealList: [],
      defaultCertificateList: [],
      uploadConfig: { fileName: 'license', maxNum: 9 },
      sealUploadConfig: { fileName: 'license', maxNum: 1 },
      detailsCtrl: false,
      editId: '',
      prevAccountName: '',
      prevMobile: '',
      isSubmit: false
    }
  },
  watch: {},
  created() {},
  beforeMount() {},
  mounted() {
    this.getDictionary()
    if (this.lawyerDetail) {
      this.getDetails(this.lawyerDetail)
      this.prevAccountName = this.lawyerDetail.accountName
      this.prevMobile = this.lawyerDetail.mobile
    } else {
      this.detailsCtrl = true
    }
  },
  updated() {},
  methods: {
    // 搜索条件省市区接口
    getCity(data) {
      let area
      if (data.length !== 0) {
        if (data.length === 1) {
          this.formValidate.province = data[0].value
          this.formValidate.city = ''
          this.formValidate.area = ''
          area = data[0].label
        } else if (data.length === 2) {
          this.formValidate.province = data[0].value
          this.formValidate.city = data[1].value
          this.formValidate.area = ''
          area = data[0].label + data[1].label
        } else if (data.length === 3) {
          this.formValidate.province = data[0].value
          this.formValidate.city = data[1].value
          this.formValidate.area = data[2].value
          area = data[0].label + data[1].label + data[2].label
        }
      } else {
        this.formValidate.province = ''
        this.formValidate.city = ''
        this.formValidate.area = ''
        area = ''
      }
    },
    // 获取文件list
    getFileList(data) {
      this.formValidate.qualifications = []
      if (data.length > 0) {
        data.forEach((item, index) => {
          const obj = {
            fileName: item.fileName,
            mediaType: item.mediaType,
            smallUrl: item.smallUrl,
            url: item.url
          }
          this.formValidate.qualifications.push(obj)
        })
      }
    },
    getSealFileList(data) {
      this.formValidate.sealAttachId = ''
      this.formValidate.sealAttachInfo = []
      if (data.length > 0) {
        data.forEach((item, index) => {
          const obj = {
            id: item.id || null,
            fileName: item.fileName,
            mediaType: item.mediaType,
            smallUrl: item.smallUrl,
            url: item.url
          }
          this.formValidate.sealAttachInfo.push(obj)
        })
        this.formValidate.sealAttachId = data[0].id || ''
      }
    },
    // 获取证件列表
    getAttachmentList(arr) {
      this.formValidate.certificateAttachs = []
      arr.forEach((item) => {
        const obj = {
          fileName: item.fileName,
          mediaType: item.mediaType,
          smallUrl: item.smallUrl,
          url: item.url
        }
        this.formValidate.certificateAttachs.push(obj)
      })
    },
    // 编辑
    handleSubmit(name) {
      if (name === 'formValidate') {
        this.$refs[name].validate((valid) => {
          if (valid) {
            this.isSubmit = true
            const offices = []
            this.formValidate.jobTime.forEach((item) => {
              if (item.office) {
                offices.push({
                  startDate: this.common.formatTime(item.usedTime[0], 1),
                  endDate: this.common.formatTime(item.usedTime[1], 1),
                  lawOffice: item.office
                })
              }
            })
            // 在这里提交数据
            const ajaxData = {
              password: this.formValidate.password,
              isLawyer: this.formValidate.memberIdentity === '1',
              name: this.formValidate.name,
              sex: this.formValidate.sex,
              certificateType: this.formValidate.certificateType,
              certificateNumber: this.formValidate.certificateNumber,
              mobile: this.formValidate.mobile,
              mail: this.formValidate.mail,
              province: this.formValidate.province,
              city: this.formValidate.city,
              area: this.formValidate.area,
              address: this.formValidate.address,
              certificateAttachs: this.formValidate.certificateAttachs,
              // fxNotary: this.formValidate.fxNotary,
              isReceiveSms: this.formValidate.isReceiveSms === '1',
              sealAttachInfo: this.formValidate.sealAttachInfo.length && this.formValidate.sealAttachInfo[0] || {},
              sealAttachId: this.formValidate.sealAttachId,
              settlementScope: this.formValidate.settlementScope,
              materialScope: this.formValidate.materialScope,
              practiceInfo: {
                lawOffice: this.formValidate.lawOffice,
                lawLicense: this.formValidate.lawLicense
              },
              skillList: this.formValidate.skill.map(item => { return { skill: item } }),
              qualifications: this.formValidate.qualifications,
              remark: this.formValidate.remark,
              officeList: offices[0] ? offices : []
            }
            let url
            if (this.editId) {
              ajaxData.accountName = this.formValidate.accountName
              url = '/base/lawyer/' + this.editId + '/base'
              this.$patch(url, ajaxData).then(res => {
                this.isSubmit = false
                if (res.code === 0) {
                  // 关闭表单
                  this.$emit('changeEditCtrl', false)
                  this.$Message.success('操作成功!')
                } else {
                  this.$Message.error(res.message)
                }
              })
            } else {
              url = '/base/lawyer/member'
              ajaxData.accountName = this.formValidate.accountName
              this.$post(url, ajaxData).then(res => {
                this.isSubmit = false
                if (res.code === 0) {
                  // 关闭表单
                  this.$emit('changeEditCtrl', false)
                  this.$Message.success('操作成功!')
                } else {
                  this.$Message.error(res.message)
                }
              })
            }
          }
        })
      }
    },
    // 执业信息添加按钮
    handleAdd() {
      this.formValidate.jobTime.push({
        usedTime: [],
        office: ''
      })
    },
    // 执业信息删除按钮
    handleRemove(index) {
      this.formValidate.jobTime.splice(index, 1)
    },
    // 改变成员类型
    changeMemberIdentity(data) {
      if (data !== '1') {
        this.formValidate.lawLicense = ''
        this.formValidate.skill = []
        this.formValidate.remark = ''
        this.formValidate.isReceiveSms = ''
        this.formValidate.sealAttachInfo = []
        this.formValidate.sealAttachId = ''
        this.formValidate.jobTime = [
          {
            usedTime: [],
            office: ''
          }
        ]
        this.formValidate.qualifications = []
        this.defaultList = []
        this.defaultSealList = []
      }
    },
    // 获取字典数据接口
    async getDictionary() {
      this.sexArr = await this.common.getDictionaryItems('sex')
      this.memberIdentityArr = await this.common.getDictionaryItems('member_identity')
      this.skillArr = await this.common.getDictionaryItems('skill_type')
      this.certificateType = await this.common.getDictionaryItems('certificate_type')
    },
    getLocation(data) {
      this.formValidate.location = []
      if (data.length > 0) {
        data.forEach(item => {
          item.cities.forEach(city => {
            this.formValidate.location.push({ province: item.provinceCode, city: city.code })
          })
        })
      } else {
        this.formValidate.location = []
      }
    },
    // 赋值
    getDetails(lawyerDetail) {
      const base = lawyerDetail
      console.log('详情信息', base)
      // 基本信息
      this.editId = base.id
      this.formValidate.name = base.name
      this.formValidate.sex = base.sex
      this.formValidate.memberIdentity = base.isLawyer ? '1' : '0'
      this.formValidate.certificateType = base.certificateType
      this.formValidate.certificateNumber = base.certificateNumber
      this.formValidate.lawOffice = base.practiceInfo && base.practiceInfo.lawOffice
      this.formValidate.mobile = base.mobile
      this.formValidate.mail = base.mail
      this.cityList = [base.province, base.city, base.area]
      this.formValidate.settlementScope = base.settlementScope
      this.formValidate.materialScope = base.materialScope
      this.formValidate.address = base.address
      // this.formValidate.fxNotary = base.teamInfo.fxNotary
      this.formValidate.isReceiveSms = base.isReceiveSms ? '1' : '0'
      this.formValidate.sealAttachInfo = base.teamInfo.sealAttachInfo ? [base.teamInfo.sealAttachInfo] : []
      this.formValidate.sealAttachId = base.teamInfo.sealAttachId
      this.defaultSealList = base.teamInfo.sealAttachInfo ? [base.teamInfo.sealAttachInfo] : [] // 附件默认值
      this.formValidate.certificateAttachs = []
      this.defaultCertificateList = []
      base.certificateAttachs.forEach((attItem) => {
        const obj = {
          fileName: attItem.fileName,
          mediaType: attItem.mediaType,
          smallUrl: attItem.smallUrl,
          url: attItem.url
        }
        this.formValidate.certificateAttachs.push(obj)
        this.defaultCertificateList.push(obj)
      })
      // 执业信息
      this.formValidate.lawLicense = base.practiceInfo && base.practiceInfo.lawLicense
      this.formValidate.skill = base.skillList.length > 0 ? base.skillList.map(item => { return item.skill }) : []
      this.formValidate.remark = base.remark
      this.formValidate.qualifications = base.qualifications || []
      this.defaultList = base.qualifications || []
      // 历史单位
      this.formValidate.jobTime = []
      this.formValidate.jobTime = lawyerDetail.officeList && lawyerDetail.officeList.map((item, index) => {
        return {
          office: item.lawOffice,
          usedTime: [this.common.formatTime(item.startDate), this.common.formatTime(item.endDate)]
        }
      })
      if (this.formValidate.jobTime.length === 0) {
        this.formValidate.jobTime.push({
          office: '',
          usedTime: []
        })
      }
      this.detailsCtrl = true
    }
  }
}
</script>
<style lang="sass" scoped>
@import './information.scss';
</style>



// WEBPACK FOOTER //
// src/view/personalCenter/editLawyer.vue